import { ProviderType } from "@redotech/redo-integrations-definitions-common/integration/integration-schema-definition";
import type { infer as zInfer } from "zod";
import { array, number, object, string, enum as zEnum } from "zod";

export const getGlobalEIntegration = {
  name: "getGlobalEIntegration" as const,
  input: object({}),
  output: object({
    globalEIntegration: object({
      username: string().nullish(),
      apiDomain: string(),
      provides: array(
        zEnum([
          ProviderType.Refund,
          ProviderType.Shipping,
          ProviderType.ReturnSync,
        ]),
      ).optional(),
      returnSync: object({
        returnShippingMethodId: number(),
        providerCode: string().optional(),
      }),
    }).optional(),
  }),
};

export type GlobalEIntegration = zInfer<typeof getGlobalEIntegration.output>;
